<template>
    <v-container>
        <input type="hidden" id="booking">
        <!--<v-row>-->
        <!--<div class="d-flex d-sm-none">XS</div>-->
        <!--<div class="d-none d-sm-flex d-md-none">SM</div>-->
        <!--<div class="d-none d-md-flex d-lg-none">MD</div>-->
        <!--<div class="d-none d-lg-flex d-xl-none">LG</div>-->
        <!--<div class="d-none d-xl-flex">XL</div>-->
        <!--</v-row>-->
        <v-row v-if="loading" align="center"
               justify="center">

            <v-col
                    cols="12"
            >
                <v-text-field color="grey" loading disabled></v-text-field>
            </v-col>
        </v-row>
        <v-row v-else-if="tpl == 'house'">
            <v-col cols="12">
                <CoolLightBox
                        :items="images"
                        :index="image"
                        @close="image = null">
                </CoolLightBox>
                <h1 class="font-weight-bold display-1 text-center" v-if="lang == 'en'">{{ page.name_en }}</h1>
                <h1 class="font-weight-bold display-1 text-center" v-if="lang == 'pt'">{{ page.name_pt }}</h1>
                <h1 class="font-weight-bold display-1 text-center" v-if="lang == 'es'">{{ page.name_es }}</h1>
                <hr>
            </v-col>
            <!--images mobile-->
            <v-col cols="12" v-if="$vuetify.breakpoint.smAndDown">
                <v-row>
                    <v-img
                            :src="imgDefault"
                            max-width="100%"
                            aspect-ratio="1"
                            class="grey lighten-2"
                            @click="image = 0"
                    >
                    </v-img>
                </v-row>
                <v-row>
                    <v-col
                            v-for="(img, idx) in images"
                            v-if="idx < 4 && idx > 0"
                            :key="'imgkey'+idx"
                            class="d-flex child-flex"
                            cols="3"
                    >
                        <img

                                :src="img.thumbnail"
                                :alt="img.alt"
                                class="open-tinybox"
                                @click="image = idx"
                                style="max-height: 80px"
                        >
                    </v-col>
                    <v-col
                            cols="3"
                    >
                        <v-card flat outlined :hover="true" class="d-flex">
                            <v-img
                                    src="../assets/img/mais.jpg"
                                    class="grey lighten-2 open-tinybox"
                                    gradient="to bottom, rgba(0,0,0,.4), rgba(0,0,0,.4)"
                                    @click="image = 0"
                            >
                                <template v-slot:placeholder>
                                    <v-row
                                            class="fill-height ma-0"
                                            align="center"
                                            justify="center"
                                    >
                                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                    </v-row>
                                </template>
                            </v-img>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
            <!--images desktop-->
            <v-col cols="4" v-if="$vuetify.breakpoint.mdAndUp">
                <v-row>
                    <v-col cols="3" xl="2" lg="3" md="3">
                        <v-container fluid>
                            <v-row>
                                <v-col
                                        v-for="(img, idx) in images"
                                        v-if="idx < 6"
                                        :key="'imgkey1'+idx"
                                        class="d-flex child-flex"
                                        cols="12"
                                >
                                    <v-card flat outlined :hover="true" class="d-flex">
                                        <v-img
                                                :src="img.thumbnail"
                                                class="grey lighten-2"
                                                @click="changeImage(img.thumbnail)"
                                        >
                                            <template v-slot:placeholder>
                                                <v-row
                                                        class="fill-height ma-0"
                                                        align="center"
                                                        justify="center"
                                                >
                                                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                                </v-row>
                                            </template>
                                        </v-img>
                                    </v-card>
                                </v-col>
                                <v-col
                                        class="d-flex child-flex"
                                        cols="12"
                                >
                                    <v-card flat outlined :hover="true" class="d-flex">
                                        <v-img
                                                src="../assets/img/mais.jpg"
                                                class="grey lighten-2 open-tinybox"
                                                gradient="to bottom, rgba(0,0,0,.4), rgba(0,0,0,.4)"
                                                @click="image = 0"
                                        >
                                            <template v-slot:placeholder>
                                                <v-row
                                                        class="fill-height ma-0"
                                                        align="center"
                                                        justify="center"
                                                >
                                                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                                </v-row>
                                            </template>
                                        </v-img>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-col>
                    <v-col cols="10" xl="10" lg="9" md="9">
                        <v-img
                                :src="imgDefault"
                                aspect-ratio="1"
                                class="grey lighten-2"
                                @click="image = 0"
                        >
                        </v-img>
                    </v-col>
                </v-row>
            </v-col>
            <!--details-->
            <v-col cols="12" md="4">
                <v-row v-if="$vuetify.breakpoint.mdAndUp">
                    <v-rating
                            :value="page.rate.rate"
                            color="amber"
                            dense
                            half-increments
                            readonly
                            size="20"
                    ></v-rating>
                    <div class="grey--text">
                        {{ page.rate.rate }} ({{ page.rate.total }}) &nbsp;
                    </div>
                    <div class="black--text">
                        {{ page.location}}
                    </div>
                </v-row>
                <v-row>
                    <v-list>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{page.guests}}
                                    <span v-if="lang== 'en'">guests</span>
                                    <span v-if="lang== 'es'">invitados</span>
                                    <span v-if="lang== 'pt'">hóspedes</span>                                                ·
                                    {{page.rooms}}
                                    <span v-if="lang== 'en'">rooms</span>
                                    <span v-if="lang== 'es'">dormitorios</span>
                                    <span v-if="lang== 'pt'">quartos</span>
                                    · {{page.bed}}
                                    <span v-if="lang== 'en'">beds</span>
                                    <span v-if="lang== 'es'">camas</span>
                                    <span v-if="lang== 'pt'">camas</span>
                                    · {{page.bath}}
                                    <span v-if="lang== 'en'">baths</span>
                                    <span v-if="lang== 'es'">baños</span>
                                    <span v-if="lang== 'pt'">banheiros</span>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item two-line v-for="(bullet,index) in page.bullets_en" :key="index+'bulleten'" v-if="lang == 'en'">
                            <v-list-item-icon>
                                <v-icon>{{bullet.icon}}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{bullet.title}}</v-list-item-title>
                                <v-list-item-subtitle class="wrap-text">{{bullet.description}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item two-line v-for="(bullet,index) in page.bullets_es" :key="index+'bulletes'" v-if="lang == 'es'">
                            <v-list-item-icon>
                                <v-icon>{{bullet.icon}}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{bullet.title}}</v-list-item-title>
                                <v-list-item-subtitle class="wrap-text">{{bullet.description}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item two-line v-for="(bullet,index) in page.bullets_pt" :key="index+'bulletpt'" v-if="lang == 'pt'">
                            <v-list-item-icon>
                                <v-icon>{{bullet.icon}}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{bullet.title}}</v-list-item-title>
                                <v-list-item-subtitle class="wrap-text">{{bullet.description}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>

                </v-row>
            </v-col>
            <!-- booking -->
            <v-col cols="12" md="4" style="position: fixed;z-index: 999; right: 15px; top:230px" v-if="$vuetify.breakpoint.mdAndUp">
                <v-card
                        elevation="2"
                >
                    <v-card-text>
                        <v-row>
                            <v-col cols="6">
                                <p class="font-weight-bold display-1 green--text">
                                    ${{ page.price }}/<span v-if="lang=='en'">night</span>
                                    <span v-if="lang=='pt'">noite</span>
                                    <span v-if="lang=='es'">noche</span>
                                </p>
                            </v-col>
                            <v-col cols="6">
                                <v-btn text>
                                    <v-rating
                                            :value="page.rate.rate"
                                            color="amber"
                                            dense
                                            half-increments
                                            readonly
                                            size="20"
                                    ></v-rating>
                                    <div class="grey--text ml-4">
                                        {{ page.rate.rate }} ({{ page.rate.total }})
                                    </div>
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md=6>
                                <v-dialog
                                        ref="dialog"
                                        v-model="modal"
                                        :return-value.sync="checkIn"
                                        persistent
                                        width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                                v-model="checkIn"
                                                label="Check-in"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker v-if="lang =='en'"
                                                   v-model="checkIn"
                                                   full-width
                                                   scrollable
                                                   :min="dataAtual"
                                                   :allowed-dates="allowedDates"
                                    >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                                text
                                                color="primary"
                                                @click="modal = false"
                                        >
                                            Cancel
                                        </v-btn>
                                        <v-btn
                                                text
                                                color="primary"
                                                @click="saveCheckIn"
                                        >
                                            OK
                                        </v-btn>
                                    </v-date-picker>
                                    <v-date-picker v-if="lang =='pt'"
                                                   v-model="checkIn"
                                                   full-width
                                                   scrollable
                                                   :min="dataAtual"
                                                   :allowed-dates="allowedDates"
                                                   locale="pt-br"
                                    >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                                text
                                                color="primary"
                                                @click="modal = false"
                                        >
                                            Cancel
                                        </v-btn>
                                        <v-btn
                                                text
                                                color="primary"
                                                @click="saveCheckIn"
                                        >
                                            OK
                                        </v-btn>
                                    </v-date-picker>
                                    <v-date-picker v-if="lang =='es'"
                                                   v-model="checkIn"
                                                   full-width
                                                   scrollable
                                                   :min="dataAtual"
                                                   :allowed-dates="allowedDates"
                                                   locale="es-es"
                                    >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                                text
                                                color="primary"
                                                @click="modal = false"
                                        >
                                            Cancel
                                        </v-btn>
                                        <v-btn
                                                text
                                                color="primary"
                                                @click="saveCheckIn"
                                        >
                                            OK
                                        </v-btn>
                                    </v-date-picker>
                                </v-dialog>
                            </v-col>
                            <v-col cols="12" md=6>
                                <v-dialog
                                        ref="dialog1"
                                        v-model="modal1"
                                        :return-value.sync="checkOut"
                                        persistent
                                        width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                                :disabled="disabledCheckOut"
                                                v-model="checkOut"
                                                label="Check-out"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker v-if="lang =='en'"
                                                   v-model="checkOut"
                                                   full-width
                                                   scrollable
                                                   :min="dataMinCheckouT"
                                                   :max="dataMaxCheckouT"
                                                   :show-current="dataMinCheckouT"
                                                   :allowed-dates="allowedDates"
                                    >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                                text
                                                color="primary"
                                                @click="modal1 = false"
                                        >
                                            Cancel
                                        </v-btn>
                                        <v-btn
                                                text
                                                color="primary"
                                                @click="saveCheckOut"
                                        >
                                            OK
                                        </v-btn>
                                    </v-date-picker>
                                    <v-date-picker v-if="lang =='pt'"
                                                   v-model="checkOut"
                                                   full-width
                                                   scrollable
                                                   :min="dataMinCheckouT"
                                                   :max="dataMaxCheckouT"
                                                   :show-current="dataMinCheckouT"
                                                   :allowed-dates="allowedDates"
                                                   locale="pt-br"
                                    >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                                text
                                                color="primary"
                                                @click="modal = false"
                                        >
                                            Cancel
                                        </v-btn>
                                        <v-btn
                                                text
                                                color="primary"
                                                @click="saveCheckOut"
                                        >
                                            OK
                                        </v-btn>
                                    </v-date-picker>
                                    <v-date-picker v-if="lang =='es'"
                                                   v-model="checkOut"
                                                   full-width
                                                   scrollable
                                                   :min="dataMinCheckouT"
                                                   :max="dataMaxCheckouT"
                                                   :show-current="dataMinCheckouT"
                                                   :allowed-dates="allowedDates"
                                                   locale="es-es"
                                    >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                                text
                                                color="primary"
                                                @click="modal = false"
                                        >
                                            Cancel
                                        </v-btn>
                                        <v-btn
                                                text
                                                color="primary"
                                                @click="saveCheckOut"
                                        >
                                            OK
                                        </v-btn>
                                    </v-date-picker>
                                </v-dialog>
                            </v-col>
                            <v-col cols="12">
                                <v-select v-if="lang == 'en' "
                                          v-model="hospede"
                                          :items="hospedes"
                                          label="Guests"
                                          outlined
                                ></v-select>
                                <v-select v-if="lang == 'pt' "
                                          v-model="hospede"
                                          :items="hospedes"
                                          label="Hospedes"
                                          outlined
                                ></v-select>
                                <v-select v-if="lang == 'es' "
                                          v-model="hospede"
                                          :items="hospedes"
                                          label="Invitados"
                                          outlined
                                ></v-select>
                            </v-col>
                            <v-col cols="12">
                                <p v-if="lang=='en' && erro.date" class="text-center" style="color: red;">Fill in the dates correctly</p>
                                <p v-if="lang=='pt'  && erro.date" class="text-center" style="color: red;">Preencha as datas corretamente</p>
                                <p v-if="lang=='es'  && erro.date" class="text-center" style="color: red;">Complete las fechas correctamente</p>
                                <div v-if="erro.booking">
                                    <v-alert type="error" dense outlined  v-for="(item,index) in msg" :key="index">
                                        {{ item }}
                                    </v-alert>
                                </div>
                                <v-btn
                                        :loading="loadButton"
                                        rounded
                                        elevation="2"
                                        block
                                        color="orange"
                                        large
                                        @click="nextStep"
                                >
                                    <span v-if="lang == 'en' ">Check availability</span>
                                    <span v-if="lang == 'pt' ">Verificar disponibilidade</span>
                                    <span v-if="lang == 'es' ">Consultar disponibilidad</span>
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row v-if="checkOut != '' ">
                            <v-col cols="12">
                                <v-divider></v-divider>
                                <p class="font-weight-bold title mt-1 green--text">
                                    ${{ page.price }} x
                                    {{days}}
                                    <span v-if="lang=='en'">night</span>
                                    <span v-if="lang=='pt'">noite</span>
                                    <span v-if="lang=='es'">noche</span>
                                    <strong class="float-right">
                                        ${{ (page.price*days) | number_format_real }}
                                    </strong>
                                </p>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <!--description-->
            <v-col cols="12" md="8">
                <p class="font-weight-medium headline text-center">
                    <span v-if="lang == 'en'">Description</span>
                    <span v-if="lang == 'pt'">Descrição</span>
                    <span v-if="lang == 'es'">Descripción</span>
                </p>
                <hr>
                <div v-html="page.en" v-if="lang == 'en'"></div>
                <div v-html="page.pt" v-if="lang == 'pt'"></div>
                <div v-html="page.es" v-if="lang == 'es'"></div>
            </v-col>
            <!--reviews-->
            <v-col cols="12" md="8">
                <p class="font-weight-medium headline text-center">
                    <span v-if="lang == 'en'">Reviews</span>
                    <span v-if="lang == 'pt'">Avaliações</span>
                    <span v-if="lang == 'es'">Reseñas</span>
                </p>
                <hr>
                <div style="max-height: 500px;overflow: auto">
                    <v-card class="mb-5" v-for="(review , index) in page.reviews" :key="'review'+index">
                        <v-card-title>{{ review.name }}</v-card-title>
                        <v-card-text>
                            <v-row
                                    align="center"
                                    class="mx-0"
                            >
                                <v-rating
                                        :value="review.rate"
                                        color="amber"
                                        dense
                                        half-increments
                                        readonly
                                        size="14"
                                ></v-rating>
                            </v-row>
                            <div class="my-4 subtitle-1">
                                {{ review.date }}
                            </div>
                            <div>
                                {{ review.text }}
                            </div>
                        </v-card-text>
                    </v-card>
                </div>
            </v-col>
            <!--mobile-->
            <div style="position: fixed;bottom: 0;width: 100%;z-index: 999;" v-if="$vuetify.breakpoint.smAndDown">
                <v-card
                        elevation="2"
                        class="ma-0"
                        outlined
                >
                    <v-card-text class="pt-0 pb-0">
                        <v-row>
                            <v-col cols="6">
                                <p class="font-weight-bold title green--text mb-0">
                                    ${{ page.price }}/<span v-if="lang=='en'">night</span>
                                    <span v-if="lang=='pt'">noite</span>
                                    <span v-if="lang=='es'">noche</span>
                                </p>
                                <p>
                                    <v-icon class="yellow--text">mdi-star</v-icon>
                                    <span class="grey--text ml-4">
                                            {{ page.rate.rate }} ({{ page.rate.total }})
                                        </span>
                                </p>
                            </v-col>
                            <v-col cols="6">
                                <v-dialog
                                        v-model="modal2"
                                        persistent
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                                rounded
                                                elevation="2"
                                                color="orange"
                                                large
                                                dark
                                                block
                                                v-bind="attrs"
                                                v-on="on"
                                        >
                                            <span v-if="lang == 'en' ">Reserve</span>
                                            <span v-if="lang == 'pt' ">Reservar</span>
                                            <span v-if="lang == 'es' ">reserva</span>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <v-row>
                                                <v-col cols="12" md=6>
                                                    <v-dialog
                                                            ref="dialog"
                                                            v-model="modal"
                                                            :return-value.sync="checkIn"
                                                            persistent
                                                            width="290px"
                                                    >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field
                                                                    v-model="checkIn"
                                                                    label="Check-in"
                                                                    prepend-icon="mdi-calendar"
                                                                    readonly
                                                                    v-bind="attrs"
                                                                    v-on="on"
                                                            ></v-text-field>
                                                        </template>
                                                        <v-date-picker v-if="lang =='en'"
                                                                       v-model="checkIn"
                                                                       full-width
                                                                       scrollable
                                                                       :min="dataAtual"
                                                                       :allowed-dates="allowedDates"
                                                        >
                                                            <v-spacer></v-spacer>
                                                            <v-btn
                                                                    text
                                                                    color="primary"
                                                                    @click="modal = false"
                                                            >
                                                                Cancel
                                                            </v-btn>
                                                            <v-btn
                                                                    text
                                                                    color="primary"
                                                                    @click="saveCheckIn"
                                                            >
                                                                OK
                                                            </v-btn>
                                                        </v-date-picker>
                                                        <v-date-picker v-if="lang =='pt'"
                                                                       v-model="checkIn"
                                                                       full-width
                                                                       scrollable
                                                                       :min="dataAtual"
                                                                       :allowed-dates="allowedDates"
                                                                       locale="pt-br"
                                                        >
                                                            <v-spacer></v-spacer>
                                                            <v-btn
                                                                    text
                                                                    color="primary"
                                                                    @click="modal = false"
                                                            >
                                                                Cancel
                                                            </v-btn>
                                                            <v-btn
                                                                    text
                                                                    color="primary"
                                                                    @click="saveCheckIn"
                                                            >
                                                                OK
                                                            </v-btn>
                                                        </v-date-picker>
                                                        <v-date-picker v-if="lang =='es'"
                                                                       v-model="checkIn"
                                                                       full-width
                                                                       scrollable
                                                                       :min="dataAtual"
                                                                       :allowed-dates="allowedDates"
                                                                       locale="es-es"
                                                        >
                                                            <v-spacer></v-spacer>
                                                            <v-btn
                                                                    text
                                                                    color="primary"
                                                                    @click="modal = false"
                                                            >
                                                                Cancel
                                                            </v-btn>
                                                            <v-btn
                                                                    text
                                                                    color="primary"
                                                                    @click="saveCheckIn"
                                                            >
                                                                OK
                                                            </v-btn>
                                                        </v-date-picker>
                                                    </v-dialog>
                                                </v-col>
                                                <v-col cols="12" md=6>
                                                    <v-dialog
                                                            ref="dialog1"
                                                            v-model="modal1"
                                                            :return-value.sync="checkOut"
                                                            persistent
                                                            width="290px"
                                                    >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field
                                                                    :disabled="disabledCheckOut"
                                                                    v-model="checkOut"
                                                                    label="Check-out"
                                                                    prepend-icon="mdi-calendar"
                                                                    readonly
                                                                    v-bind="attrs"
                                                                    v-on="on"
                                                            ></v-text-field>
                                                        </template>
                                                        <v-date-picker v-if="lang =='en'"
                                                                       v-model="checkOut"
                                                                       full-width
                                                                       scrollable
                                                                       :min="dataMinCheckouT"
                                                                       :max="dataMaxCheckouT"
                                                                       :show-current="dataMinCheckouT"
                                                                       :allowed-dates="allowedDates"
                                                        >
                                                            <v-spacer></v-spacer>
                                                            <v-btn
                                                                    text
                                                                    color="primary"
                                                                    @click="modal = false"
                                                            >
                                                                Cancel
                                                            </v-btn>
                                                            <v-btn
                                                                    text
                                                                    color="primary"
                                                                    @click="saveCheckOut"
                                                            >
                                                                OK
                                                            </v-btn>
                                                        </v-date-picker>
                                                        <v-date-picker v-if="lang =='pt'"
                                                                       v-model="checkOut"
                                                                       full-width
                                                                       scrollable
                                                                       :min="dataMinCheckouT"
                                                                       :max="dataMaxCheckouT"
                                                                       :show-current="dataMinCheckouT"
                                                                       :allowed-dates="allowedDates"
                                                                       locale="pt-br"
                                                        >
                                                            <v-spacer></v-spacer>
                                                            <v-btn
                                                                    text
                                                                    color="primary"
                                                                    @click="modal = false"
                                                            >
                                                                Cancel
                                                            </v-btn>
                                                            <v-btn
                                                                    text
                                                                    color="primary"
                                                                    @click="saveCheckOut"
                                                            >
                                                                OK
                                                            </v-btn>
                                                        </v-date-picker>
                                                        <v-date-picker v-if="lang =='es'"
                                                                       v-model="checkOut"
                                                                       full-width
                                                                       scrollable
                                                                       :min="dataMinCheckouT"
                                                                       :max="dataMaxCheckouT"
                                                                       :show-current="dataMinCheckouT"
                                                                       :allowed-dates="allowedDates"
                                                                       locale="es-es"
                                                        >
                                                            <v-spacer></v-spacer>
                                                            <v-btn
                                                                    text
                                                                    color="primary"
                                                                    @click="modal = false"
                                                            >
                                                                Cancel
                                                            </v-btn>
                                                            <v-btn
                                                                    text
                                                                    color="primary"
                                                                    @click="saveCheckOut"
                                                            >
                                                                OK
                                                            </v-btn>
                                                        </v-date-picker>
                                                    </v-dialog>
                                                </v-col>
                                                <v-col cols="12">
                                                    <v-select v-if="lang == 'en' "
                                                              v-model="hospede"
                                                              :items="hospedes"
                                                              label="Guests"
                                                              outlined
                                                    ></v-select>
                                                    <v-select v-if="lang == 'pt' "
                                                              v-model="hospede"
                                                              :items="hospedes"
                                                              label="Hospedes"
                                                              outlined
                                                    ></v-select>
                                                    <v-select v-if="lang == 'es' "
                                                              v-model="hospede"
                                                              :items="hospedes"
                                                              label="Invitados"
                                                              outlined
                                                    ></v-select>
                                                </v-col>
                                                <v-col cols="12">
                                                    <v-btn
                                                            rounded
                                                            elevation="2"
                                                            block
                                                            color="orange"
                                                            large
                                                            @click="nextStep"
                                                    >
                                                        <span v-if="lang == 'pt' ">Verificar disponibilidade</span>
                                                        <span v-if="lang == 'en' ">Check availability</span>
                                                        <span v-if="lang == 'es' ">Consultar disponibilidad</span>

                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                    color="blue darken-1"
                                                    text
                                                    @click="modal2 = false"
                                            >
                                                Close
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </div>
            <v-btn icon x-small :to="'/checkout'" id="cartBtn"></v-btn>
        </v-row>
        <v-row v-else-if="tpl == 'community'">
            <v-col
                    cols="12"
            >
                <h1 class="font-weight-bold display-1 text-center ">{{ page.name }}</h1>
                <hr>
                <v-row>
                    <!-- mobile -->
                    <v-col cols="12" v-if="$vuetify.breakpoint.smAndDown">
                        <div>
                            <v-carousel :show-arrows="false">
                                <v-carousel-item
                                        v-for="(img,i) in page.images"
                                        :key="'comm'+i"
                                        :src="cdnUrl+img.image"
                                        reverse-transition="fade-transition"
                                        transition="fade-transition"
                                ></v-carousel-item>
                            </v-carousel>
                        </div>
                    </v-col>
                    <!-- desktop -->
                    <v-col cols="4" v-if="$vuetify.breakpoint.mdAndUp">
                        <v-row>
                            <v-col cols="3" xl="2" lg="3" md="3">
                                <v-container fluid>
                                    <v-row>
                                        <v-col
                                                v-for="(image,index) in page.images"
                                                :key="'comm1'+index"
                                                class="d-flex child-flex"
                                                cols="12"
                                        >
                                            <v-card flat outlined :hover="true" class="d-flex">
                                                <v-img
                                                        :src="cdnUrl+image.image"
                                                        class="grey lighten-2"
                                                        @click="changeImage(cdnUrl+image.image)"
                                                >
                                                    <template v-slot:placeholder>
                                                        <v-row
                                                                class="fill-height ma-0"
                                                                align="center"
                                                                justify="center"
                                                        >
                                                            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                                        </v-row>
                                                    </template>
                                                </v-img>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-col>
                            <v-col cols="10" xl="10" lg="9" md="9">
                                <v-img
                                        :src="imgDefault"
                                        aspect-ratio="1"
                                        class="grey lighten-2"
                                >
                                </v-img>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="8" v-if="$vuetify.breakpoint.mdAndUp">
                        <div v-html="page.en" v-if="lang=='en'"></div>
                        <div v-html="page.es" v-if="lang=='es'"></div>
                        <div v-html="page.pt" v-if="lang=='pt'"></div>
                    </v-col>
                    <v-col cols="12" v-if="$vuetify.breakpoint.smAndDown">
                        <div v-html="page.en" v-if="lang=='en'"></div>
                        <div v-html="page.es" v-if="lang=='es'"></div>
                        <div v-html="page.pt" v-if="lang=='pt'"></div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col
                            cols="12"
                    >
                        <p class="font-weight-bold mb-1 text-center display-2" v-if="lang == 'en' ">Properties</p>
                        <p class="font-weight-bold mb-1 text-center display-2" v-if="lang == 'pt' ">Imóveis</p>
                        <p class="font-weight-bold mb-1 text-center display-2" v-if="lang == 'es' ">Propiedades</p>
                        <p class="font-weight-bold mb-1 text-center subtitle-1" v-if="lang == 'en' ">Meet some properties</p>
                        <p class="font-weight-bold mb-1 text-center subtitle-1" v-if="lang == 'pt' ">Conheça alguns imóveis</p>
                        <p class="font-weight-bold mb-1 text-center subtitle-1" v-if="lang == 'es' ">Conoce algunas propiedades</p>
                        <hr>
                    </v-col>
                    <v-col cols="12">
                        <v-container>
                            <v-row>
                                <v-col
                                        v-for="(house,index) in page.houses"
                                        :key="'h1'+index"
                                        cols="12"
                                        lg="4"
                                        md="4"
                                        sm="6"
                                        xs="4"
                                >
                                    <v-card
                                            v-if="lang == 'en'"
                                            class="mx-auto"
                                            :hover="true"
                                            :to="house.meta_url"
                                    >
                                        <v-img
                                                v-if="$vuetify.breakpoint.smAndUp"
                                                class="white--text align-end"
                                                height="500"
                                                max-height="500"
                                                min-height="170"
                                                :src="cdnUrl+house.images[0].image"
                                                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                                        >
                                            <v-card-title v-if="lang == 'en'">{{ house.name_en }}</v-card-title>
                                            <v-card-title v-if="lang == 'es'">{{ house.name_es }}</v-card-title>
                                            <v-card-title v-if="lang == 'pt'">{{ house.name_pt }}</v-card-title>
                                        </v-img>
                                        <v-img
                                                v-else
                                                class="white--text align-end"
                                                height="210"
                                                max-height="420"
                                                min-height="170"
                                                :src="cdnUrl+house.images[0].image"
                                                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                                        >
                                            <v-card-title v-if="lang == 'en'">{{ house.name_en }}</v-card-title>
                                        <v-card-title v-if="lang == 'es'">{{ house.name_es }}</v-card-title>
                                        <v-card-title v-if="lang == 'pt'">{{ house.name_pt }}</v-card-title>
                                        </v-img>
                                        <!--descriptions-->
                                        <v-card-text class="text--primary d-none d-lg-flex" style="height: 100px">
                                            <div style="overflow: auto">
                                                <span v-if="lang=='en'">{{house.short_description_en}}</span>
                                                <span v-if="lang=='es'">{{house.short_description_es}}</span>
                                                <span v-if="lang=='pt'">{{house.short_description_pt}}</span>
                                            </div>
                                        </v-card-text>
                                        <v-card-actions >
                                            <v-btn
                                                    class="title"
                                                    color="green"
                                                    text
                                            >
                                        <span>${{ house.price || number_format_real}}/
                                            <span v-if="lang=='en'">night</span>
                                            <span v-if="lang=='pt'">noite</span>
                                            <span v-if="lang=='es'">noche</span>
                                        </span>
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                    <v-card
                                            v-if="lang == 'pt'"
                                            class="mx-auto"
                                            :hover="true"
                                            :to="'pt/'+house.meta_url"
                                    >
                                        <v-img
                                                v-if="$vuetify.breakpoint.smAndUp"
                                                class="white--text align-end"
                                                height="500"
                                                max-height="500"
                                                min-height="170"
                                                :src="cdnUrl+house.images[0].image"
                                                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                                        >
                                            <v-card-title v-if="lang == 'en'">{{ house.name_en }}</v-card-title>
                                        <v-card-title v-if="lang == 'es'">{{ house.name_es }}</v-card-title>
                                        <v-card-title v-if="lang == 'pt'">{{ house.name_pt }}</v-card-title>
                                        </v-img>
                                        <v-img
                                                v-else
                                                class="white--text align-end"
                                                height="210"
                                                max-height="420"
                                                min-height="170"
                                                :src="cdnUrl+house.images[0].image"
                                                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                                        >
                                            <v-card-title v-if="lang == 'en'">{{ house.name_en }}</v-card-title>
                                        <v-card-title v-if="lang == 'es'">{{ house.name_es }}</v-card-title>
                                        <v-card-title v-if="lang == 'pt'">{{ house.name_pt }}</v-card-title>
                                        </v-img>
                                        <!--descriptions-->
                                        <v-card-text class="text--primary d-none d-lg-flex" style="height: 100px">
                                            <div style="overflow: auto">
                                                <span v-if="lang=='en'">{{house.short_description_en}}</span>
                                                <span v-if="lang=='es'">{{house.short_description_es}}</span>
                                                <span v-if="lang=='pt'">{{house.short_description_pt}}</span>
                                            </div>
                                        </v-card-text>
                                        <v-card-actions >
                                            <v-btn
                                                    class="title"
                                                    color="green"
                                                    text
                                            >
                                        <span>${{ house.price || number_format_real}}/
                                            <span v-if="lang=='en'">night</span>
                                            <span v-if="lang=='pt'">noite</span>
                                            <span v-if="lang=='es'">noche</span>
                                        </span>
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                    <v-card
                                            v-if="lang == 'es'"
                                            class="mx-auto"
                                            :hover="true"
                                            :to="'es/'+house.meta_url"
                                    >
                                        <v-img
                                                v-if="$vuetify.breakpoint.smAndUp"
                                                class="white--text align-end"
                                                height="500"
                                                max-height="500"
                                                min-height="170"
                                                :src="cdnUrl+house.images[0].image"
                                                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                                        >
                                            <v-card-title v-if="lang == 'en'">{{ house.name_en }}</v-card-title>
                                        <v-card-title v-if="lang == 'es'">{{ house.name_es }}</v-card-title>
                                        <v-card-title v-if="lang == 'pt'">{{ house.name_pt }}</v-card-title>
                                        </v-img>
                                        <v-img
                                                v-else
                                                class="white--text align-end"
                                                height="210"
                                                max-height="420"
                                                min-height="170"
                                                :src="cdnUrl+house.images[0].image"
                                                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                                        >
                                            <v-card-title v-if="lang == 'en'">{{ house.name_en }}</v-card-title>
                                        <v-card-title v-if="lang == 'es'">{{ house.name_es }}</v-card-title>
                                        <v-card-title v-if="lang == 'pt'">{{ house.name_pt }}</v-card-title>
                                        </v-img>
                                        <!--descriptions-->
                                        <v-card-text class="text--primary d-none d-lg-flex" style="height: 100px">
                                            <div style="overflow: auto">
                                                <span v-if="lang=='en'">{{house.short_description_en}}</span>
                                                <span v-if="lang=='es'">{{house.short_description_es}}</span>
                                                <span v-if="lang=='pt'">{{house.short_description_pt}}</span>
                                            </div>
                                        </v-card-text>
                                        <v-card-actions >
                                            <v-btn
                                                    class="title"
                                                    color="green"
                                                    text
                                            >
                                        <span>${{ house.price || number_format_real}}/
                                            <span v-if="lang=='en'">night</span>
                                            <span v-if="lang=='pt'">noite</span>
                                            <span v-if="lang=='es'">noche</span>
                                        </span>
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-col>
                                <!--coming soon houses 100% accessible for person with reduced mobility-->
                                <v-col
                                        v-for="n in 3"
                                        :key="'n1'+n"
                                        cols="12"
                                        lg="4"
                                        md="4"
                                        sm="6"
                                        xs="4"


                                >
                                    <v-card
                                            class="mx-auto"
                                            :hover="true"
                                            outlined
                                    >
                                        <!--no images-->
                                        <v-img
                                                v-if="$vuetify.breakpoint.smAndUp"
                                                class="white--text align-end"
                                                height="500"
                                                max-height="500"
                                                min-height="170"
                                                src="../assets/img/coming_soon.jpg"
                                        >

                                        </v-img>
                                        <v-img
                                                v-else
                                                class="white--text align-end"
                                                height="210"
                                                max-height="420"
                                                min-height="170"
                                                src="../assets/img/coming_soon.jpg"
                                                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                                        >
                                        </v-img>
                                        <!--descriptions-->
                                        <v-card-text class="text--primary d-none d-lg-flex" style="height: 100px;font-weight: bold;font-size: 30px;">
                                            <div style="overflow: auto">
                                                <span v-if="lang=='en'">houses 100% accessible for person with reduced mobility</span>
                                                <span v-if="lang=='pt'">casas 100% acessíveis para pessoas com mobilidade reduzida</span>
                                                <span v-if="lang=='es'">casas 100% accesibles para personas con movilidad reducida</span>
                                            </div>
                                        </v-card-text>
                                        <v-card-actions >
                                            <v-btn
                                                    class="title"
                                                    color="green"
                                                    text

                                            >
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-col>
                                <!--Coming Soon-->
                                <v-col
                                        v-for="n in 2"
                                        :key="'n2'+n"
                                        cols="12"
                                        lg="4"
                                        md="4"
                                        sm="6"
                                        xs="4"


                                >
                                    <v-card
                                            class="mx-auto"
                                            :hover="true"
                                            outlined
                                    >
                                        <!--no images-->
                                        <v-img
                                                v-if="$vuetify.breakpoint.smAndUp"
                                                class="white--text align-end"
                                                height="500"
                                                max-height="500"
                                                min-height="170"
                                                src="../assets/img/coming_soon.jpg"
                                        >
                                        </v-img>
                                        <v-img
                                                v-else
                                                class="white--text align-end"
                                                height="210"
                                                max-height="420"
                                                min-height="170"
                                                src="../assets/img/coming_soon.jpg"
                                                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                                        >
                                        </v-img>
                                        <!--descriptions-->
                                        <v-card-text class="text--primary d-none d-lg-flex" style="height: 100px">
                                            <div style="overflow: auto"></div>
                                        </v-card-text>
                                        <v-card-actions >
                                            <v-btn
                                                    class="title"
                                                    color="green"
                                                    text

                                            >
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row v-else-if="tpl == 'blog' ">
            <v-col
                    cols="12"
            >
                <h1 class="font-weight-bold display-1 text-center" v-if="lang == 'en'">{{ page.title_en }}</h1>
                <h1 class="font-weight-bold display-1 text-center" v-if="lang == 'es'">{{ page.title_es }}</h1>
                <h1 class="font-weight-bold display-1 text-center" v-if="lang == 'pt'">{{ page.title_pt }}</h1>
                <hr class="mb-3">
                <div v-html="page.en" v-if="lang == 'en'"></div>
                <div v-html="page.es" v-if="lang == 'es'"></div>
                <div v-html="page.pt" v-if="lang == 'pt'"></div>
            </v-col>
        </v-row>
    </v-container>
</template>
<style>
    .v-list-item__subtitle{
        white-space: normal !important;
    }
    .wrap-text {
        -webkit-line-clamp: unset !important;
        white-space: normal !important;
    }
</style>
<script>
    //import Tinybox  from "vue-tinybox";
    import CoolLightBox from 'vue-cool-lightbox';
    import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';

    export default {
        props: {
            lang: { type: String },
            appUrl: { type: String },
            cdnUrl: { type: String },
        },
        components: {

            CoolLightBox
        },
        directives: {

            CoolLightBox
        },
        metaInfo () {
            return {
                title: this.title,
                meta: [
                    {description: this.description},
                    {keywords: this.keywords}
                ]
            }
        },
        data () {
            return {
                title:"Best Choice Vacation",
                description:"Best Choice Vacation",
                keywords:"Best Choice Vacation",
                loading:true,
                erro:{
                    date:false,
                    booking:false,
                },
                current:window.location.pathname,
                tpl:"home",
                imgDefault:"",
                page:{
                    disabledDates:{}
                },
                image:null,
                images: [],
                modal: false,
                modal1: false,
                modal2: false,
                dataAtual:new Date().toISOString().substr(0, 10),
                dataMinCheckouT:new Date().toISOString().substr(0, 10),
                dataMaxCheckouT:"",
                checkIn:"",
                checkOut:"",
                hospedes:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25],
                hospede:1,
                disabledDates:{},
                disabledCheckOut:true,
                days:1,
                loadButton:false,
                msg:[],
                items: [
                    {
                        title: 'Image 1',
                        description: "Description 1",
                        src: 'data:image/jpeg;base64,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',
                    },
                    {
                        title: 'a beautiful mountain view',
                        description: "Description 2",
                        src: 'data:image/jpeg;base64,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',
                    },
                ],
                index: null
            }
        },
        methods:{
            nextStep(){
                this.erro.date = false;
                if(this.checkOut == "" || this.checkIn == ""){
                    this.erro.date = true;
                }else{
                    this.loadButton = true;
                    var arr = {
                        token:localStorage.token,
                        id:this.page.id,
                        checkIn:this.checkIn,
                        checkOut:this.checkOut,
                        hospede:this.hospede,
                        price:this.page.price
                    };
                    arr = JSON.stringify(arr);
                    this.$http.post(this.appUrl+"/store/checkout/step1",arr).then(response => {
                        this.loadButton = false;
                        if(response.data.erro){
                            this.erro.booking = true;
                            this.msg = response.data.msg;
                        }else{
                            document.getElementById('cartBtn').click();
                        }
                    });
                }
            },
            saveCheckIn(){
                this.checkOut = "";
                this.$refs.dialog.save(this.checkIn);

                var booking = document.getElementById("booking").value;
                booking = booking.split(',');

                this.disabledDates = booking;
                this.disabledDates.push(this.checkIn);

                this.dataMinCheckouT = this.checkIn;

                if(this.disabledDates.length > 1){
                    var time = new Date(this.checkIn);
                    var check = false;
                    for(var days = 2;days <= 300 ;days ++){
                        if(check == false){
                            var outraData = new Date(time);
                            outraData.setDate(time.getDate() + days);
                            //console.log(outraData.toISOString().substr(0, 10));
                            for(var i = 0;i < this.disabledDates.length;i++){
                                if(this.disabledDates[i] == outraData.toISOString().substr(0, 10)){
                                    check = true;
                                    this.dataMaxCheckouT = outraData.toISOString().substr(0, 10);
                                }
                            }
                        }
                    }
                    if(check == false){
                        this.dataMaxCheckouT = "";
                    }
                }
                this.disabledCheckOut = false;
            },
            saveCheckOut(){
                this.$refs.dialog1.save(this.checkOut);
            },
            init() {
                var u1 = this.current.split('/');
                u1 = u1.pop();
                var u2 = window.location.pathname.split('/');
                u2 = u2.pop();
                if(u1 != u2){
                    this.current = window.location.pathname;
                    this.loadPage();
                }
            },
            loadPage(){
                this.$http.get(this.appUrl+"/store/getPage/"+this.$route.params.urlPage).then(response =>{
                    this.loading = false;
                    if(response.data.erro){
                        console.log('404')
                    }else if(response.data.tpl == 'house'){
                        this.tpl = 'house';
                        this.page = response.data.data;
                        this.imgDefault = this.cdnUrl+this.page.images[0].image;
                        this.title = this.page.meta_title;
                        this.description = this.page.meta_description;
                        this.keywords = this.page.meta_keywords;
                        //set images
                        for(var i = 0; i < this.page.images.length; i ++){
                            var img = {
                                src:this.cdnUrl+this.page.images[i].image,
                                alt:this.page.name,
                                caption:this.page.name,
                                thumbnail:this.cdnUrl+this.page.images[i].image
                            };
                            this.images.push(img);
                        }
                        //set guests
                        this.hospedes = [];
                        for(var j = 1;j <= this.page.guests; j++){
                            this.hospedes.push(j);
                        }
                        //set disable dates
                        this.disabledDates = this.page.disabledDates;
                        document.getElementById("booking").value = this.disabledDates;
                        //verifica se tem parametros
                        var newTerm = window.location.search.slice(1);
                        var partes = newTerm.split('&');
                        var data = {};
                        partes.forEach(function (parte) {
                            var chaveValor = parte.split('=');
                            var chave = chaveValor[0];
                            var valor = chaveValor[1];
                            data[chave] = valor;
                        });

                        if(data.init && data.end && data.guests){
                            this.checkIn = data.init;
                            this.checkOut = data.end;
                            this.hospede = parseInt(data.guests);
                            this.disabledCheckOut = false;
                        }

                    }else if(response.data.tpl == 'community'){
                        this.tpl = 'community';
                        this.page = response.data.data;

                        this.imgDefault = this.cdnUrl+this.page.images[0].image;

                        this.title = this.page.meta_title;
                        this.description = this.page.meta_description;
                        this.keywords = this.page.meta_keywords;
                    }else if(response.data.tpl == 'blog'){
                        this.tpl = 'blog';
                        this.page = response.data.data;

                        this.title = this.page.meta_title;
                        this.description = this.page.meta_description;
                        this.keywords = this.page.meta_keywords;
                    }else{
                        console.log('404')
                    }
                });
            },
            changeImage(src){
                this.imgDefault = src;
            },
            allowedDates(val){
                return !(this.disabledDates.indexOf(val) !== -1);
            },
        },
        watch: {
            checkOut: function (val) {
                const now = new Date(val); // Data de hoje
                const past = new Date(this.checkIn); // Outra data no passado

                const diff = Math.abs(now.getTime() - past.getTime());
                const days = Math.ceil(diff / (1000 * 60 * 60 * 24));

                this.days = days;
            },
        },
        mounted(){
            this.loadPage();
            var self = this;
            setInterval(function(){
                    self.init();
                }, 700
            );
        },
        filters:{
            number_format_real(valor){
                return String(parseFloat(valor).toFixed(2));
            },
        }
    }
</script>